export default {
  name: 'divider',
  component_path: 'modules/procedures/blocks/static/BlockDivider'
}